
import { debounce } from 'vue-debounce';
import { Component, Vue } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';

import { PRODUCT_TYPE } from '../constants';
import { Picto, Product, Zone } from '../interfaces';

import ModalFormule from './ModalFormule.vue';
import ModalProductDetail from './ModalProduct.vue';
import ProductCard from './ProductCard.vue';

@Component({
  name: 'ListCards',
  components: {
    ModalProductDetail,
    ProductCard,
    ModalFormule,
  },
})
export default class ListCards extends Vue {
  @Getter('menu/loadingMenu') loadingMenu!: boolean;

  @Getter('menu/error') error!: boolean;

  @Getter('menu/products') products!: Product[];

  @Getter('menu/formulaZones') formulaZones!: Zone[];

  @Getter('menu/currentProductTypes') currentProductTypes!: Picto[];

  @Getter('menu/isActivatedComment') isActivatedComment!: boolean;

  @Action('menu/updateSelectedProductTypeName') updateSelectedProductTypeName!: (name: string) => void;

  typeProduct = PRODUCT_TYPE;

  formulaProducts(id: string): Product[] {
    return this.$store.getters['menu/formulaProducts'](id);
  }

  productsTypes(typeProduct: PRODUCT_TYPE | string): Product[] {
    return this.products.filter((product) => product.type === typeProduct);
  }

  hasProductsFormulas(): boolean {
    return this.formulaZones.some((formula) => this.formulaProducts(formula.code).length);
  }

  handleScroll(): void {
    debounce(() => {
      const element = document.getElementById(this.currentProductTypes[0].name);
      if (element && window.scrollY >= element.offsetTop) {
        const productTypes = this.currentProductTypes.map((productType) => ({
          name: productType.name,
          position: document.getElementById(productType.name)?.offsetTop || 0,
        }));
        const selectedProductType = productTypes.reduce((a, b) =>
          a.position <= window.scrollY && b.position > window.scrollY ? a : b
        );
        const filterDay = document.getElementById('FilterDay');
        this.updateSelectedProductTypeName(
          filterDay && filterDay.getBoundingClientRect().top + 150 < 0
            ? selectedProductType.name
            : ''
        );
      } else {
        this.updateSelectedProductTypeName('');
      }
    }, '1000ms')();
  }

  mounted(): void {
    document.addEventListener('scroll', this.handleScroll);
  }

  beforeDestroy(): void {
    document.removeEventListener('scroll', this.handleScroll);
  }
}
